export default "__VITE_ASSET__15sq5qDd__"